export const BALANCE_PAYMENT_TITLES = {
  replenishment: {
    title: 'Баланс и оплата',
    description: 'Здесь вы можете пополнить баланс, активировать услуги и скачать платёжные документы',
  },
  documents: {
    title: 'Документы',
    description: 'Здесь вы можете скачать закрывающие документы',
  },
  history: {
    title: 'История платежей',
    description: 'Здесь вы можете посмотреть историю платежей и скачать счёт',
  },
} as const;

export type BalancePaymentTab = keyof typeof BALANCE_PAYMENT_TITLES;
